<template>
  <v-container class="white-wrapper" fluid>
    <div
      style="
        max-width: 25rem;
        margin: 0 auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0 1rem;
      "
    >
      <div>
        <v-card class="mx-auto" elevation="4" outlined>
          <v-card-title>
            <v-row justify="space-between">
              <div class="d-flex card-title pl-2">
                <img style="width: 0.8rem" src="@/assets/svg/USDT-logo.svg" />
                <span class="text-subtitle-2 card-title-margin"> UMUC(BEP-20 : {{ balanceCalc && comma(balanceCalc) }} ) </span>
                              

                <template v-if="available">
                  <v-chip
                    style="padding: 0 0.81rem"
                    color="success"
                    label
                    x-small
                  >
                    OPEN
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip style="padding: 0 5px" color="error" label x-small>
                    STAKING
                  </v-chip>
                </template>
              </div>
              <div class="d-flex pr-2" align="right">
                <span v-show="!available" class="text-caption">
                  <!-- 2020/12/09 - 2021/12/09 -->
                </span>
              </div>
            </v-row>
          </v-card-title>
          <v-card-text style="text-align: center; padding: 2rem 1rem">
            <span class="headline font-weight-bold text--primary">
              {{ staking.sum && comma(staking.sum) }} UMUC(BEP-20)
              
              <v-btn
                icon                                             
                title="trade History"
                @click="goHistory()" 
              >
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </span>

            <!-- <div class="slider-container">
              
              <span class="text-caption slider-label mr-2">0</span>
              <vue-slider
                v-if="!available"
                class="staking-slider"
                v-model="slider"
                :min="0"
                :max="config.staking_day"
                :interval="1"
                :dot-options="[{ disabled: true }]"
                :tooltip="'always'"
                dotSize="0"
                width="80%"
                :process-style="{
                  backgroundColor: '#3e0ba5'
                }"
                :rail-style="{
                  backgroundColor: '#F1F2F5'
                }"
              >
                <template v-slot:tooltip>
                  <div class="custom-tooltip">
                    <img
                      style="width: 0.8rem"
                      src="@/assets/svg/custom-mark.svg"
                    />
                  </div>
                </template>
              </vue-slider>
              <vue-slider
                v-else
                class="staking-slider"
                :v-model="0"
                :min="0"
                :max="config.staking_day"
                :interval="1"
                :dot-options="[{ disabled: true }]"
                dotSize="0"
                width="80%"
                :process-style="{
                  backgroundColor: '#3e0ba5'
                }"
                :rail-style="{
                  backgroundColor: '#F1F2F5'
                }"
              ></vue-slider>
              <span class="text-caption slider-label ml-2">{{
                config.staking_day
              }}</span>
            </div> -->
          </v-card-text>
        </v-card>
        
      <!-- <v-card> 
        <v-card-text>
          <v-radio-group v-model="radios" row >            
            <v-radio label="Option 1" value="radio-1" selected></v-radio>
            <v-radio label="Option 2" value="radio-2"></v-radio>
            <v-radio label="Option 3" value="radio-3"></v-radio> 
          </v-radio-group>
        </v-card-text>
      </v-card> -->



    
    

      

        <v-form ref="form" v-model="valid" lazy-validation class="mt-4">
          <div class="d-flex flex-column">
            
            <div class="d-flex flex-column" cols="11" sm="6">
              <span class="v-label">{{ $t('staking.period') }}</span>
              <v-radio-group v-model="selectPeriod" row >            
                <v-radio :label="$t('staking.days30')" value="30"></v-radio>
                <v-radio :label="$t('staking.days60')" value="60"></v-radio>
                <v-radio :label="$t('staking.days90')" value="90"></v-radio> 
              </v-radio-group>
            </div>


            <!-- <div class="d-flex flex-column" cols="11" sm="6">
              <span class="v-label">수량</span>                          
              <v-select
                autocomplete="off" 
                clearable
                v-model="amount"     
                :rules="amountRules" 
                :items="['1000', '2000', '3000', '4000', '5000']"
              ></v-select>

            </div> -->            
            


            <div class="d-flex flex-column" cols="11" sm="6">
              <v-text-field
                :label="$t('staking.quantity')"
                :placeholder="$t('staking.quantityPlaceholder')"
                type="number"
                min="1000"
                max="100000"
                v-model="amount"
                :rules="amountRules"
                @blur="amountCheck"
                
                clearable
              ></v-text-field>
              <!-- @keydown="amountCheck" -->
            </div>

            <div class="d-flex flex-column hide"  v-if="false" >
              <span class="v-label">{{ $t('staking.expectedValue') }}</span>
              <div
                class="expect-container text-h5 font-weight-bold error--text"
              >
                <span>{{ expect && comma(expect) }}</span>
              </div>           
            </div>


            <div class="d-flex flex-column">
               
              <div style="font-size: small;padding:15px 5px;white-space: pre-line;" >
                {{ $t('staking.description') }}
              </div>           
            </div>

          </div>
        </v-form> 
      </div>


      <div>
        <v-btn
          :disabled="!available"
          class="font-weight-bold mb-4"
          color="primary"
          block
          x-large
          @click="submit"
        >
          {{ available ? $t('staking.stakingBtn') : $t('staking.stakingStatus') }}
        </v-btn>
      </div>
    </div>

    <!-- 
        <v-dialog v-model="confirmModal" persistent max-width="30rem">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
              <div>{{ $t('send.confirmModal.amount') }}</div>
              <div>{{ amount }} {{ select_coin }}</div>
              <div>{{ $t('send.confirmModal.address') }}</div>
              <div>{{ toAddress }}</div>
              <div>{{ $t('send.confirmModal.message') }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-0">
              <v-btn
                color="#AFAFAF"
                width="50%"
                text
                x-large
                class="font-weight-bold"
                @click="confirmModal = false"
              >
                취소
              </v-btn>
              <v-divider vertical></v-divider>
              <v-btn
                color="error"
                width="50%"
                text
                x-large
                class="font-weight-bold"
                @click="submit"
              >          
                승인
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 
    -->



  </v-container>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  data: () => ({
    confirmModal:false  ,
    configId: null,
    selectPeriod : '30' ,  
    slider: 20,
    max: 100,
    step: 1,
    available: true,
    valid: true,
    amount: null ,
    stakingMin: 1000,
    stakingMax: 100000,
    stakingPer: 10,
    staking_sum:0 , 
    balanceCalc: 0 , 
    amountRules: []
  }),
  computed: {
    wallet() {
      return this.$store.getters.wallet
    },
    config() {
      return this.$store.getters.staking.config
    },
    staking() {
      return this.$store.getters.staking.staking
    },
    expect() { 

      if (this.amount) {

        switch(this.selectPeriod) { 
          case '30' : this.stakingPer  = 8 ; break ; 
          case '60' : this.stakingPer  = 9 ; break ; 
          case '90' : this.stakingPer  = 10 ;  break ;  
        };  

        // const dec = Number(this.amount.replace(/,/g, "")).split('.')[1] ; 
        const dec =Number(this.amount.replace(/,/g, "")) ; 
        if (dec)
          return ((this.stakingPer * this.amount) / 100).toFixed(dec.length + 2)
      }
      return this.amount && (this.stakingPer * this.amount) / 100
    },  
    balance() {             
      let _balance = ( parseFloat(this.wallet.filter((i) => i.name === "UMUC")[0].balance) || 0 )       
      return _balance ;
    }
  },
  components: {
    VueSlider
  },
  created() {
    this.$store.commit('activeMenu', 'staking')
    this.$store.dispatch('FETCH_STAKINGINFO').then((res) => {
      this.available = res.data.config.staking_available === 1
      this.stakingMin = res.data.config.staking_min
      this.stakingPer = res.data.config.staking_per
      this.configId = res.data.config.config_id
      // this.staking_sum = res.data.staking.sum || 0 ;         
      this.staking_sum = res.data.staking[0].total || 0 ;         

      let _balance = ( parseFloat(this.wallet.filter((i) => i.name === "UMUC")[0].balance) || 0 )        ; 
      
      this.balanceCalc = parseFloat(  _balance-this.staking_sum ) ; 

      this.amountRules = [
        (v) => !!v || this.$t('staking.enterQuantity'),
        (v) => (v && v >= this.stakingMin) || this.$t('staking.minQuantity', { min: this.stakingMin }),        
        (v) => (v && v <= this.balance) || this.$t('staking.checkAvailable'),         
      ]
    })
  },
  methods: {
    amountCheck(evt){ 

      if( evt ) ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault() ; 
      if( this.amount >this.balance ) this.amount = this.balance ; 

      if( this.amount > this.stakingMax  ) {
        this.amount = this.stakingMax ;                   
      } ;  
      if(evt.type=='blur') this.amount = this.amount - (this.amount%1000)  ;            

    } , 
    goHistory(){
      this.$router.push({path:'/config/history/eth'}) 
    } ,    
    openConfirmModal(){
      this.confirmModal = true ;
    } , 
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true)

        this.$store
          .dispatch('FETCH_WALLET')
          .then((res) => {
            const params = {
              //token: 'ccc'
              token: 'alc'
            }
            return this.$store.dispatch('AVAIL_TOKEN', params)
            // return res
          })
          .then((res) => {
            const data = res.data
            const sum =
              parseFloat(data.locked.sum) + parseFloat(data.staking.sum)

            // const plp_wallet = this.wallet.filter(
            //   (i) => i.name === 'CCC'
            // )[0] || { balance: 0 }

            if (parseFloat(this.balance) < parseFloat(this.amount) + sum) throw 'alc' ; //throw 'ccc' 
              

            const parmas = {
              configId: this.configId,
              amount: this.amount,
              period : this.selectPeriod ,               
              token: parseFloat(this.balance) , 
              typs: 'alc'
            }
            return this.$store.dispatch('staking_token', parmas)
          })
          .then((res) => {
            if (res.data.status && res.data.status !== 'false') {
              this.$store.commit('loading', false)
              this.$store.dispatch('modal', {
                on: true,
                msg: this.$t('staking.success')
              })
              this.$store.dispatch('FETCH_STAKINGINFO').then((res) => {

                this.amount = null ; 
                this.selectPeriod = '30' ; 

                this.available = res.data.config.staking_available === 1
                this.stakingMin = res.data.config.staking_min
                this.stakingPer = res.data.config.staking_per
                this.configId = res.data.config.config_id


                this.staking_sum = res.data.staking[0].total || 0 ;         
                let _balance = ( parseFloat(this.wallet.filter((i) => i.name === "UMUC")[0].balance) || 0 )  ;                 
                this.balanceCalc = parseFloat(  _balance-this.staking_sum ) ; 

              })
            } else throw 'server_error'
          })
          .catch((err) => {
            // console.log(err)
            // if (err === 'ccc') {
            if (err === 'alc') {
              this.$store.dispatch('modal', {
                on: true,
                msg: this.$t('staking.checkQuantity')
              })
            } else {
              this.$store.dispatch('modal', {
                on: true,
                msg: `${this.$t('staking.failed')}<br/>(${err})`
              })
            }
            this.$store.commit('loading', false)
          })
      }
    }
  }
}
</script>

<style>
.card-title {
  align-items: center;
  /* width: 7rem; */
}
.card-title-margin {
  margin: 0 0.3rem;
}
.color-label {
  width: 100%;
  height: 2rem;
  background-color: #3e0ba5;
}
.slider-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}
.slider-label {
  color: #b1b1b1;
}
.expect-container {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  min-height: 2.5rem;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
}
.custom-tooltip {
  transform: translate(0px, 10px);
}
</style>
